import React, { useState, useEffect } from 'react';
import { Link } from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setAddMrdSuccessStatusActionCreator,
  setAssociateHandlerSuccessStatusActionCreator,
} from '../redux/actions/DeviceInformationActions';
import { getAddMrdSuccessStatus, getAssociateHandlerSuccessStatus } from '../redux/selectors/DeviceInformationSelectors';
import AddMrdForm from '../add-mrd/containers/AddMrdForm';
import AssociateHandlerForm from '../associate-handler/containers/AssociateHandlerForm';
import MRDContactManagementContainer from '../contact-management/containers/MRDContactManagementContainer';
import { MrdDeviceWizardStyle } from '../component/MrdDeviceWizard.styles';

function MrdDeviceWizard(props) {
  const {
    addMrdSuccessStatus,
    setAddMrdStatus,
    associateHandlerSuccessStatus,
    setAssociateHandlerStatus,
  } = props;
  const [step, setStep] = useState(1);

  const [selectedImpc, setSelectedImpc] = useState(null);
  const [addedMrdName, setAddedMrdName] = useState('');

  const closeWizard = () => {
    document.getElementById('link-mrd-wizard-close').click();
    setStep(1);
  };

  const renderSwitch = () => {
    switch (step) {
    case 1:
      return (
        <AddMrdForm
          closeWizard={closeWizard}
          setSelectedImpc={setSelectedImpc}
          setAddedMrdName={setAddedMrdName}
        />
      );
    case 2:
      return (
        <AssociateHandlerForm
          closeWizard={closeWizard}
          selectedImpc={selectedImpc}
          addedMrdName={addedMrdName}
        />
      );
    case 3:
      return (
        <MRDContactManagementContainer
          closeWizard={closeWizard}
          selectedImpc={selectedImpc}
          addedMrdName={addedMrdName}
        />
      );
    default:
      return <></>;
    }
  };

  useEffect(() => {
    if (addMrdSuccessStatus) {
      setAddMrdStatus(false);
      setStep(2);
    }
    if (associateHandlerSuccessStatus) {
      setAssociateHandlerStatus(false);
      setStep(3);
    }
  }, [addMrdSuccessStatus, associateHandlerSuccessStatus]);

  return (
    <MrdDeviceWizardStyle>
      <div className="add-mrd-container">
        <Link id="link-mrd-wizard-close" to={{ pathname: '/administration/device-info' }} />
        <div className="add-mrd-container-title">
          <h4>{`New MRD device wizard step ${step}/3`}</h4>
        </div>
        {renderSwitch()}
      </div>
    </MrdDeviceWizardStyle>
  );
}

function mapStateToProps(state) {
  return {
    addMrdSuccessStatus: getAddMrdSuccessStatus(state),
    associateHandlerSuccessStatus: getAssociateHandlerSuccessStatus(state),
  };
}

MrdDeviceWizard.propTypes = {
  addMrdSuccessStatus: PropTypes.bool,
  associateHandlerSuccessStatus: PropTypes.bool,
  setAddMrdStatus: PropTypes.func,
  setAssociateHandlerStatus: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setAddMrdStatus: setAddMrdSuccessStatusActionCreator,
  setAssociateHandlerStatus: setAssociateHandlerSuccessStatusActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MrdDeviceWizard);
